import { DEVICE_STATISTICS } from "../../../../shared";

export const deviceStatsValues = {
    online: "Online",
    offline: "Offline",
    inactive: "Inactive",
    unknown: "Unknown",
    other: "Other"
};

export const emptyDoughnut = {
    id: "emptyDoughnut",
    afterDraw(chart: any, _args: any, options: any) {
        const { datasets } = chart.data;

        const { color, width, radiusDecrease } = options;
        let hasData = false;

        let total: number = 0;
        datasets.forEach((dataset: any) =>
            dataset.data.map((item: number) => {
                total = total + item;
                return total;
            })
        );

        if (total > 0) {
            hasData = true;
        }

        if (!hasData) {
            const {
                chartArea: { left, top, right, bottom },
                ctx
            } = chart;
            const centerX = (left + right) / 2;
            const centerY = (top + bottom) / 2;
            const r = Math.min(right - left, bottom - top) / 2;
            ctx.beginPath();
            ctx.lineWidth = width || 2;
            ctx.strokeStyle = color || "rgba(255, 128, 0, 0.5)";
            ctx.arc(centerX, centerY, r - radiusDecrease || 0, 0, 2 * Math.PI);
            ctx.stroke();
        }
    }
};

export const translateStatName = (
    name: string,
    offline: string,
    online: string,
    inactive: string,
    unknown: string,
    other: string
) => {
    switch (name) {
        case deviceStatsValues.offline:
            return offline;
        case deviceStatsValues.online:
            return online;
        case deviceStatsValues.inactive:
            return inactive;
        case deviceStatsValues.unknown:
            return unknown;
        case deviceStatsValues.other:
            return other;
        default:
            return name;
    }
};

export const translateStatTitle = (
    query: string,
    activity: string,
    model: string,
    firmware: string,
    configuration: string
) => {
    switch (query) {
        case DEVICE_STATISTICS.ActivityStatus:
            return activity;
        case DEVICE_STATISTICS.Model:
            return model;
        case DEVICE_STATISTICS.CurrentFw:
            return firmware;
        case DEVICE_STATISTICS.CurrentCfg:
            return configuration;
        default:
            return query;
    }
};
